import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from "@fluentui/react-components";
import { KeyboardEvent, useEffect, useRef } from "react";
import { useImportProcessingOverlayStyles } from "./ImportProcessingOverlay.styles";
import { IImportProcessingOverlayProps } from "./ImportProcessingOverlay.types";

const SPINNER_LABEL = "Import in progress";
const ESCAPE_KEY = "Escape";
const DESCRIPTION_TEXT =
  "This can take up to a minute. You can edit the plan again once it's done.";

export const ImportProcessingOverlay = ({
  isVisible,
  fileName,
  onHide,
}: IImportProcessingOverlayProps): JSX.Element => {
  const styles = useImportProcessingOverlayStyles();
  const returnFocusRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (isVisible) {
      returnFocusRef.current = document.activeElement as HTMLElement | null;
      return;
    }
    returnFocusRef.current?.focus();
    returnFocusRef.current = null;
  }, [isVisible]);

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === ESCAPE_KEY) onHide();
  };

  return (
    <Dialog
      open={isVisible}
      modalType="alert"
      onOpenChange={(_event, data) => {
        if (!data.open) onHide();
      }}
    >
      <DialogSurface className={styles.surface} onKeyDown={handleKeyDown}>
        <DialogBody className={styles.body}>
          <DialogContent className={styles.content}>
            <Spinner size="small" aria-label={SPINNER_LABEL} />
            <div className={styles.text}>
              <DialogTitle className={styles.title}>
                {`Importing from ${fileName}…`}
              </DialogTitle>
              <p className={styles.description}>{DESCRIPTION_TEXT}</p>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
